import { Asset, Title } from "@sicredi/react";
import React from "react";

export default function SessionLostPage() {
  return (
    <div
      data-testid="session-lost"
      style={{
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Title as="h1">Sessão perdida</Title>
      <Asset name="action-not-found" />
    </div>
  );
}
